import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from 'components/pure/utils/Dialog';
import InputField from 'components/pure/utils/form/InputField';
import ToastActions from '@store/toast/ToastActions';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import FolderActions from 'actions/inbox/FolderActions';
import Folder from 'records/Folder';
import './CreateFolderDialog.styl';

const MAX_FOLDER_NAME_LENGTH = 85;

export default class CreateFolderDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      folder: new Folder(),
      errors: {},
    };
  }
  async onSubmit() {
    const {folder} = this.state;
    if (!folder.name || !folder.name.trim()) {
      this.setState({errors: {name: 'Name is invalid'}});
      return;
    }
    try {
      await FolderActions.createFolder(folder);
      this.props.onRequestClose();
      ToastActions.addToast({
        message: `Successfully created folder "${this.state.folder.name}".`,
      });
    } catch (e) {
      ToastActions.addToast({
        message: `Error creating folder "${this.state.folder.name}".`,
        type: 'error',
      });
    }
  }
  render() {
    return (
      <Dialog
        className="create-folder-dialog"
        open={true}
        title="Create Folder"
        closeButton={true}
        onRequestClose={this.props.onRequestClose}
        actions={[
          <Button variant="contained" className="ev-button" color="primary" onClick={this.onSubmit}>
            Create
          </Button>,
          <Button variant="outlined" className="ev-button" onClick={this.props.onRequestClose}>
            Cancel
          </Button>,
        ]}>
        <FieldContainer label="Choose Folder Name:" error={this.state.errors.name}>
          <InputField
            value={this.state.folder.name || ''}
            autoFocus={true}
            placeholder="Folder Name"
            maxLength={MAX_FOLDER_NAME_LENGTH}
            onChange={name => this.setState({folder: this.state.folder.set('name', name)})}
          />
        </FieldContainer>
      </Dialog>
    );
  }
}
